export const environment = {
  production: false,
  API_URL: 'https://nitsa-portal-test.avanacapital.com/api/portal/v1/'
};
